module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper ati-wrapper",
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('section', {
    ref: "contentContainer",
    staticClass: "content vld-parent"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39c5352a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/ContentWrap.vue
// module id = 510
// module chunks = 1